import { isArray } from 'lodash';
import get from 'lodash.get';
import { EVENT_TYPE } from '../../../Utils/constants';
import { IWEBINAR_DATA } from '../../../Utils/types';
import { ILeadData } from '../Common/leadCall';
import {
  VALIDATION_ENUMS,
  businessEmailValidator,
  emailValidator,
  phoneValidator,
  requiredValidator,
} from '../Common/validator';
import { FORM_DATA, FORM_ERROR, IVALIDATE_FORM_RETURN_TYPE } from './types';

export const touchErrors = (errors: FORM_ERROR): FORM_ERROR => {
  const obj = {
    ...errors,
    touched: true,
  };
  return obj;
};

export const getError = (
  field: string | undefined,
  formObj: Record<string, FORM_DATA>
): IVALIDATE_FORM_RETURN_TYPE => {
  let isValid = true;

  if (!field) return { isValid: false, updatedFormErrors: formObj };

  const formField = get(formObj, [field], {}) as FORM_DATA;

  if (formField && formField?.errors?.touched) {
    let message = '';
    const validations = formField.validation;

    if (isArray(validations)) {
      validations.forEach((validation: string) => {
        switch (validation) {
          case VALIDATION_ENUMS.IS_REQUIRED:
            message = requiredValidator(formField.value, formField.label);
            break;
          case VALIDATION_ENUMS.IS_EMAIL:
            message = emailValidator(formField.value, formField.label);
            break;
          case VALIDATION_ENUMS.IS_BUSINESS_EMAIL:
            message = businessEmailValidator(formField.value, formField.label);
            break;
          case VALIDATION_ENUMS.IS_PHONE:
            message = phoneValidator(formField.value, formField.label);
            break;
          default:
            message = '';
        }
      });
    }

    const err = get(formObj, [field, 'errors'], {}) as FORM_ERROR;
    err.error = Boolean(message);
    err.message = message;

    if (message !== '') isValid = false;
  }

  return { isValid: isValid, updatedFormErrors: formObj };
};

export const getFormattedDataForLead = (
  leadFormData: Record<string, FORM_DATA>,
  webinarDetails: IWEBINAR_DATA,
  eventType: EVENT_TYPE,
  WEBINAR_TYPE: string
): ILeadData => {
  const currentDate = new Date();
  const date = currentDate.toDateString();
  const { firstName, lastName, email, phone, designation, companyName } =
    leadFormData;
  const { product, airing_date, title } = webinarDetails;

  return {
    leadData: {
      data: {
        name: firstName?.value,
        last_name: lastName?.value,
        email: email?.value,
        phone_number: phone?.value,
        designation: designation?.value,
        submitted_date: date,
        PageURL: document.URL,
        company_name: companyName?.value,
        title: title,
        product: product?.title,
        airing_date: airing_date,
        type: eventType,
      },
      type: 'contact-sales-form',
      typeName: 'Tax Experts',
    },
    leadPlatforms: {
      google_sheet: {
        sheet_name: 'webinarsLead',
      },
      ...(WEBINAR_TYPE !== 'ITR' && { salesforce: true }),
    },
  };
};
